export default __webpack_public_path__ + "static/media/SG-Green-0000.967032bc.png";